export default "__VITE_ASSET__uJ62l0uT__"